module.exports = __webpack_public_path__ + "static/media/unico-materiais-eletricos.ccffe545.webp";